import { motion } from "framer-motion";

const AboutSection = () => {
  return (
    <section
      id="about"
      className="py-24 md:py-32 relative noise-overlay"
      data-testid="about-section"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
          {/* Image */}
          <motion.div
            className="md:col-span-5"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="relative">
              <img
                src="https://customer-assets.emergentagent.com/job_afro-braiding-pro/artifacts/zb8vv6qi_IMG-20260414-WA0053.jpg"
                alt="Fulani braids by Afro Magic"
                className="w-full aspect-[3/4] object-cover"
              />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-2 border-brand-gold" />
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            className="md:col-span-7"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <p className="text-xs uppercase tracking-[0.2em] font-sans text-brand-gold mb-4">
              Our Story
            </p>
            <h2 className="font-serif text-3xl md:text-5xl text-brand-text tracking-tight mb-6 leading-tight">
              Crafting Beauty,
              <br />
              Honoring Heritage
            </h2>
            <div className="gold-line mb-8" />
            <p className="font-sans text-base text-brand-text-muted leading-relaxed mb-6">
              At Afro Magic Braiding Hair, every braid tells a story. Located in
              the heart of Southfield, Michigan, we've been transforming hair into
              art for over a decade. Our skilled braiders bring together traditional
              African techniques with contemporary styles to create looks that are
              uniquely yours.
            </p>
            <p className="font-sans text-base text-brand-text-muted leading-relaxed mb-8">
              From classic box braids to trending knotless styles, our team is
              dedicated to delivering exceptional results with care and precision.
              We also proudly serve clients from nearby Windsor, Ontario and
              surrounding areas.
            </p>
            <div className="flex items-center gap-10">
              <div>
                <p className="font-serif text-3xl text-brand-gold font-semibold">10+</p>
                <p className="font-sans text-sm text-brand-text-muted">Years Experience</p>
              </div>
              <div>
                <p className="font-serif text-3xl text-brand-gold font-semibold">5.0</p>
                <p className="font-sans text-sm text-brand-text-muted">Star Rating</p>
              </div>
              <div>
                <p className="font-serif text-3xl text-brand-gold font-semibold">2K+</p>
                <p className="font-sans text-sm text-brand-text-muted">Happy Clients</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
